<template>
  <div class="DockingDetailsTitle main">
      <div class="content">
          <span>{{title1}}</span><span> > </span><span>{{title2}}</span>
      </div>
     
    <!-- logoUrl: "../../../../public/static/images/IDG-logo.png", -->
  </div>
</template>

<script>
export default { 
    props:{
        title1:String,
        title2:String,
    },
    components:{},
    data(){
        return{

        }
    },
    created:function(){

    },
    methods:{},

}
</script>

<style scoped>
@media (max-width: 768px) {
  /* .div{
    margin-left: 10px;
    margin-right: 10px;
  } */
}
.DockingDetailsTitle{
    color: #fff;
}

.content{
    padding-top: 32px;
    padding-bottom: 25px;
}

</style>